import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";

const perks = [
  "10% off first order",
  "Brewing tips",
  "New roast alerts",
  "Limited editions",
];

const SubscribeBanner = () => {
  const [email, setEmail] = useState("");

  const join = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    window.open(
      `https://wa.me/250787255672?text=${encodeURIComponent(
        `Hi KBL — I'd like to join the Coffee Club. Email: ${email}`
      )}`,
      "_blank"
    );
    setEmail("");
  };

  return (
    <section className="relative overflow-hidden bg-espresso">
      <img
        src="/Coffee20.jpg"
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-espresso/80" />
      <div className="relative mx-auto max-w-7xl px-5 py-14 md:px-8 md:py-16">
        <div className="grid items-center gap-8 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-gold">
              Community
            </p>
            <h2 className="mt-3 font-display text-3xl text-cream md:text-4xl">
              Join the KBL Coffee Club
            </h2>
            <ul className="mt-6 grid gap-3 sm:grid-cols-2">
              {perks.map((perk) => (
                <li key={perk} className="flex items-center gap-2.5 text-sm text-cream/85">
                  <FaCheck className="text-gold" />
                  {perk}
                </li>
              ))}
            </ul>
          </div>

          <form onSubmit={join} className="rounded-2xl bg-white/95 p-6 shadow-lg">
            <label htmlFor="club-email" className="text-sm font-semibold text-espresso">
              Get started
            </label>
            <input
              id="club-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              className="mt-2 w-full rounded-md border border-cream-muted bg-cream px-4 py-3 text-sm outline-none focus:border-gold"
            />
            <button
              type="submit"
              className="mt-4 w-full rounded-md bg-espresso py-3 text-sm font-semibold text-cream transition hover:bg-espresso-soft"
            >
              Join &amp; Save 10%
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SubscribeBanner;
